import { AuthenticationModel } from './authenication.model';

export class MemberModel extends AuthenticationModel {
    
    /**
     * ç»å¥çè©±æ©
     */
    extension : string 

    /**
     * ä½¿ç¨èç»å¥ä»£ç¢¼
     */
    loginID : string

    
}
